import {
  USER_REQUEST_SENT,
  GET_USER_SUCCESS,
  UPDATE_BOTH_USER_ACTIVE_PANEL,
  GET_USER_FAILURE,
  GET_USER_LOGOUT,
  SEND_NOTIFICATION,
  NEW_NOTIFICATIONS,
  ONLINE_USERS,
  COMET_ONLINE_USERS,
  SET_REFERRAL_LINK,
  SET_UTM_LINK,
  SET_IS_ACTIVE_AS, SET_PREFERENCE, SET_CONTINUE_AS,SET_USER_TYPE
} from "./userActions";

// We need to have an initial state values
const initialState = {
  isLoading: false,
  isLoggedIn: false,
  userRole: "",
  userID: "",
  prevLoggedOutId: "",
  accessToken: "",
  otp_verified: "",
  email_verified: "",
  userData: [],
  message: "",
  error: "",
  sendNotification: [],
  newNotifications: [],
  onlineUsers: [],
  isActiveAs: undefined,
  referralLink: undefined,
  utmLink: undefined
};

// Then we need to have the reducer
const userReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_REQUEST_SENT:
      return {
        ...state,
        isLoading: true,
      };

    case GET_USER_SUCCESS:
      let userStateData = {
        ...state,
        isLoading: false,
        isLoggedIn: true,
        userRole: payload.userData.role,
        userID: payload.userData.id,
        prevLoggedOutId: payload.userData.id,
        accessToken: payload.accessToken,
        otp_verified: payload.userData.otp_verified,
        email_verified: payload.userData.email_verified,
        userData: payload.userData,
        message: payload.message,
        error: "",
        sendNotification: "",
        newNotifications: [],
      };

      if (payload.isActiveAs !== undefined) {
        userStateData = {
          ...userStateData,
          isActiveAs: payload.isActiveAs
        }
      }
      return userStateData;

    case UPDATE_BOTH_USER_ACTIVE_PANEL:
      return {
        ...state,
        isActiveAs: payload
      };

    case GET_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false,
        userRole: "",
        userID: "",
        accessToken: "",
        otp_verified: "",
        email_verified: "",
        userData: [],
        message: "",
        error: payload,
        sendNotification: "",
        newNotifications: [],
        isActiveAs: undefined
      };

    case GET_USER_LOGOUT:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false,
        userRole: "",
        userID: "",
        prevLoggedOutId: "",
        accessToken: "",
        otp_verified: "",
        email_verified: "",
        userData: [],
        message: "",
        error: "",
        sendNotification: [],
        newNotifications: [],
        onlineUsers: [],
        isActiveAs: undefined,
      };

    case SEND_NOTIFICATION:
      return {
        ...state,
        sendNotification: payload,
      };

    case NEW_NOTIFICATIONS:
      return {
        ...state,
        newNotifications: Array.isArray(payload)
          ? payload
          : [...state.newNotifications, payload],
      };

    case ONLINE_USERS:
      return {
        ...state,
        onlineUsers: payload,
      };

    case COMET_ONLINE_USERS:
      return {
        ...state,
        cometOnlineUsers: payload,
      };

    case SET_REFERRAL_LINK:
      return {
        ...state,
        referralLink: payload
      }

    case SET_UTM_LINK:
      return {
        ...state,
        utmLink: payload
      }
    case SET_IS_ACTIVE_AS:
      return {
        ...state,
        isActiveAs: payload
      }
    case SET_PREFERENCE:
      return {
        ...state,
        userData: {
          ...state.userData,
          type_of_projects: payload.type_of_projects,
          client_interest_subject_id: payload.subjects,
          plan_post_project: payload.plan_post_project,
          continue_as: payload.continue_as
        },
      };
    case SET_CONTINUE_AS:
      return {
        ...state,
        userData: {
          ...state.userData,
          continue_as: payload.continue_as
        },
      };
    case SET_USER_TYPE:
      return {
        ...state,
        userData: {
          ...state.userData,
          user_type: action.payload
        },        
      };


    default:
      return state;
  }
};

export default userReducer;
